<style lang="scss" src="./InputText.scss" scoped></style>

<template>
  <div class='input-text'>
    <div class="label">{{ label }} {{ isRequired ? '*' : ''  }}</div>

    <input
      v-if='mask'
      class="input"
      :class="{'input-error': inputError}"
      :placeholder='placeholder'
      :disabled='isDisabled'
      @blur='blur'
      @focus='focus'
      v-mask='mask'
      v-model='input'
    />

    <input
      v-else
      class="input"
      :class="{'input-error': inputError}"
      :placeholder='placeholder'
      :disabled='isDisabled'
      @blur='blur'
      @focus='focus'
      v-model='input'
    />
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  name: 'ProviderInputText',
  props: {
    value: [String, Number],
    label: String,
    placeholder: {
      type: String,
      default: 'Digite aqui...'
    },
    mask: undefined,
    isDisabled: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    validate: null
  },

  directives: { mask },

  data () {
    return {
      input: '',
      inputError: false
    }
  },

  watch: {
    input (eventValue) {
      this.$emit('input', eventValue)
    },
    value () {
      this.input = this.value
    }
  },

  mounted () {
    this.input = this.value ? this.value : ''
  },

  methods: {
    blur (e) {
      this.checkValidate()
      this.$emit('blur', e)
    },
    focus (e) {
      this.$emit('blur', e)
    },

    checkValidate () {
      this.inputError = false
      if (typeof this.validate === 'function') {
        let valid = this.validate(this.input)
        if (valid !== true) {
          this.inputError = true
        }
      }
    }
  }
}
</script>
